import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import {recursionRouter} from "@/utils/tools";
Vue.use(Vuex);

import createPersistedState from "vuex-persistedstate"

export default new Vuex.Store({
    state: {
        meunShow: false,
        initRouter: false,
        routerData: [],
        userInfo: null,
        pageJurisdiction: true,
        cachedViews: [],
    },
    getters: {
        getMeunShow(state) {
            return state.meunShow;
        },
    },

    mutations: {
        setMeunShow(state, status) {
            state.meunShow = status;
        },
        setUserInfo(state, status) {
            state.userInfo = status;
        },
        setInitRouter(state, status) {
            state.initRouter = status;
        },
        setRouterData(state, data) {
            state.routerData = data;
        },
        setJurisdiction(state, data) {
            state.pageJurisdiction = false;
        },
        //处理VUE keep_alive
        ADD_CACHED_VIEW: (state, view) => {
            if (state.cachedViews.includes(view.name)) {
                return
            }
            state.cachedViews.push(view.name)
        },

        DEL_CACHED_VIEW: (state, view) => {
            const index = state.cachedViews.indexOf(view.name)
            index > -1 && state.cachedViews.splice(index, 1)
        },
    },
    actions: {
        async addRouteData(context, roleId) {
            const addRoutes = await recursionRouter();
            if (addRoutes) {
                //添加路由
                router.addRoutes(addRoutes);
                context.commit("setRouterData", addRoutes);
                context.commit("setInitRouter", true);
            }
        },
    },

    modules: {},
});